import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Interest } from 'src/app/shared/models/user';

@Component({
  selector: 'app-profile-interest',
  templateUrl: './profile-interest.component.html',
  styleUrls: ['./profile-interest.component.scss']
})
export class ProfileInterestComponent implements OnInit {
  @Input() interests = new BehaviorSubject<Interest[]>([]);
  merged = new BehaviorSubject<Interest | null>(null);
  dummyEl = document.createElement('DIV');

  constructor() { }

  ngOnInit(): void {
    this.interests.subscribe(items => {
      if (!items || items.length === 0) { return; }
      const result = items.reduce((acc, item) => ({
        ...acc,
        clinical: acc.clinical || item.clinical || '',
        research: acc.research || item.research || '',
        service: acc.service || item.service || '',
        teaching: acc.teaching || item.teaching || '',
        clinicalExpertise: acc.clinicalExpertise || item.clinicalExpertise || '',
        researchExpertise: acc.researchExpertise || item.researchExpertise || '',
        serviceExpertise: acc.serviceExpertise || item.serviceExpertise || '',
        teachingExpertise: acc.teachingExpertise || item.teachingExpertise || '',
      }));
      this.merged.next(result);
    });
  }

  decode(text: string): string {
    let ret = '';
    this.dummyEl.innerHTML = text;
    document.body.appendChild(this.dummyEl);
    ret = this.dummyEl.textContent;
    document.body.removeChild(this.dummyEl);
    ret = ret.split('<p>&nbsp;</p>').join('');
    ret = ret.split('<strong>&nbsp;</strong>').join('');
    return ret;
  }

}
